import React from 'react'
import { useLocation } from 'react-router-dom'
import { useState } from 'react'

import BreadCrumbs from '../BreadCrumbs'
import ClaimModal from './ClaimModal'

type UnclaimedViewProps = {
  name: string
  address: string
  id: string
}

const UnclaimedView: React.FC<UnclaimedViewProps> = (props) => {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)

  const breadCrumbPages = [
    { name: 'Locations', href: '/locations' },
    { name: props.name, href: pathname },
  ]

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <BreadCrumbs breadCrumbPages={breadCrumbPages} />
      <ClaimModal placeId={props.id} open={open} onClose={handleClose} />
      <div className="mb-6 flex justify-between">
        <h1 className="text-lg font-medium leading-6 text-gray-900">{props.name}</h1>
        <button className="btn btn-primary" onClick={() => setOpen(true)}>
          Assign to customer
        </button>
      </div>
      <div className="overflow-hidden bg-white shadow sm:rounded-lg">
        <div className="flex justify-between px-4 py-5 sm:px-6">
          <h3 className="text-lg font-medium leading-6 text-gray-900">{props.name}</h3>
          <span className="tag bg-gray-100 text-gray-800">Unclaimed</span>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
          <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Address</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{props.address}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Customer</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">-</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Rating</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">-</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  )
}

export default UnclaimedView
